import React from 'react';
import { connect } from 'react-redux';

import * as AccountActions from "../data/accounts/AccountActions";

import LoadingIndicator from "../components/LoadingIndicator/LoadingIndicator";
import AccountList, {createAccountUrl} from "../components/AccountList/AccountList";

class AccountsController extends React.Component
{
    state = {
        loading: true
    };

    componentDidMount()
    {
        this.props.fetchAccountList().then(() => {
            this.setState({loading: false})
        });
    }

    render()
    {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }

        const keys = Object.keys(this.props.accounts);

        if (keys.length === 1) {
            const account = this.props.accounts[keys[0]];

            window.location = createAccountUrl(account);

            return null;
        }

        return <div className="flex h-full items-center justify-center bg-indigo-800">
            <AccountList accounts={this.props.accounts} />
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    accounts: state.accounts,
});

const mapDispatchToProps = {
    fetchAccountList: AccountActions.fetchAccountList,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountsController);
